import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import SVG from "react-inlinesvg";

//helpers:
import {useTranslation} from "react-i18next";
import {toAbsoluteUrl} from "../../../_helpers";
import {isSupportedLanguage} from "../../../../i18n/index";

//components:
import {Dropdown} from "react-bootstrap";
import TranslateIcon from "@material-ui/icons/Translate";

//actions:
import {authActions} from "../../../../app/redux/Auth/authRedux";
import {loadParameter} from "../../../../app/redux_slices/contextSlice";

//flags
import russiaFlag from "../../../_assets/images/russia-flag.png"
import romaniaFlag from "../../../_assets/images/romania-flag.png"

const LanguageDropdown = () => {
    const {t, i18n} = useTranslation();

    const getCurrentLanguage = () => {
        const detectedLang = i18n?.languages?.[0];
        const shortLang = detectedLang.slice(0, 2);
        const isSupported = isSupportedLanguage(shortLang);

        return isSupported ? detectedLang : "en-US";
    };

    const allowedLanguages = useSelector(state => loadParameter(state, "allowedLanguages"));
    const parsedAllowedLanguages =
        allowedLanguages && typeof allowedLanguages === "string" && JSON.parse(allowedLanguages);
    const isOneAllowedAndSupported =
        parsedAllowedLanguages?.length === 1 && isSupportedLanguage(parsedAllowedLanguages?.[0]?.slice(0, 2));

    //redux:
    //actions:
    const dispatch = useDispatch();

    const handleSelect = language => {
        dispatch(authActions.updateAccount({language}));
        i18n.changeLanguage(language);
    };

    useEffect(() => {
        if (isOneAllowedAndSupported && getCurrentLanguage()) {
            if (isOneAllowedAndSupported !== getCurrentLanguage()) {
                i18n.changeLanguage(parsedAllowedLanguages?.[0]);
            }
        }
    }, [isOneAllowedAndSupported]);

    const flags = [
        {
            lang: "es-ES",
            name: t("LANGUAGE.SPANISH"),
            svgUrl: <SVG src={toAbsoluteUrl("/media/svg/flags/016-spain.svg")} />,
        },
        {
            lang: "en-US",
            name: t("LANGUAGE.ENGLISH"),
            svgUrl: <SVG src={toAbsoluteUrl("/media/svg/flags/260-united-kingdom.svg")} />,
        },
        {
            lang: "ca-ES",
            name: t("LANGUAGE.CATALAN"),
            svgUrl: <img height={16} width={16} src={toAbsoluteUrl("/media/svg/flags/catalonia.svg")} alt={""} />,
        },
        {
            lang: "ru-RU",
            name: t("LANGUAGE.RUSSIAN"),
            svgUrl: <img height={16} width={16} src={russiaFlag}  alt={''}/>,
        },
        {
            lang: "ro-RO",
            name: t("LANGUAGE.ROMANIAN"),
            svgUrl: <img height={16} width={16} src={romaniaFlag}  alt={''}/>,
        },
    ];

    if (isOneAllowedAndSupported) {
        return <span />;
    }

    return (
        <Dropdown>
            <Dropdown.Toggle className="btn btn-hover-transparent-white h-45px w-45px my-auto ml-2">
                <TranslateIcon />
            </Dropdown.Toggle>

            <Dropdown.Menu className="header_menu_list language_dropdown-menu">
                {flags.map(flag => {
                    if (parsedAllowedLanguages.indexOf(flag.lang) !== -1) {
                        return (
                            <Dropdown.Item
                                key={flag.name}
                                onClick={() => handleSelect(flag.lang)}
                                active={getCurrentLanguage() === flag.lang}
                            >
                                <span className="svg-icon svg-icon-sm svg-icon-primary m-0 mr-3 svg-icon-sort">
                                    {flag.svgUrl}
                                </span>
                                {flag.name}
                            </Dropdown.Item>
                        );
                    }
                    return null;
                })}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default LanguageDropdown;
